import { render, staticRenderFns } from "./ReceivableStatement.vue?vue&type=template&id=e3808afc&scoped=true&"
import script from "./ReceivableStatement.vue?vue&type=script&lang=js&"
export * from "./ReceivableStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3808afc",
  null
  
)

export default component.exports